//
//  @file EnrollFIDO.jsx
//  @author Sergii Oryshchenko <sergii.orishchenko@gmail.com>
//  @see https://github.com/os-v/
//
//  Created on 03.06.20.
//  Copyright 2020 Sergii Oryshchenko. All rights reserved.
//  Any usage of this material is strictly forbidden unless prior written permission is obtained from Sergii Oryshchenko <sergii.orishchenko@gmail.com>.
//

import React, { Component } from "react";

import EnrollBase from "views/User/EnrollBase.jsx";

import EnrollFIDOStep1 from "views/User/EnrollFIDOStep1.jsx";
import EnrollFIDOStep2 from "views/User/EnrollFIDOStep2.jsx";
import EnrollFIDOStep3 from "views/User/EnrollFIDOStep3.jsx";

import RapidaIDService from "scripts/RapidaIDService.jsx";
import RapidaIDSession from "scripts/RapidaIDSession.jsx";

import ImgTile from "assets/img/TileFIDO.png";

class EnrollFIDO extends Component
{

    constructor(props)
    {

        super(props);

        this.TokenInfo = {
            UUID: "",
            Name: "",
            PIN: ""
        };

        this.TokenData = [ ];

        this.OnPrepareEdit = this.OnPrepareEdit.bind(this);
        this.OnTokenEnrolled = this.OnTokenEnrolled.bind(this);
        this.OnTokenRemoved = this.OnTokenRemoved.bind(this);

    }

    componentDidMount()
    {

        this.ReloadTokenData();

    }

    ReloadTokenData()
    {

        this.TokenData.splice(0, this.TokenData.length);

        var pData = RapidaIDSession.GetFIDOData();
        for(var iItem = 0; iItem < pData.length; iItem++)
            this.TokenData.push({ UUID: pData[iItem].UUID, Name: pData[iItem].Name });

        this.forceUpdate();

        console.log(pData);

    }

    OnPrepareEdit(iItem, OnResult)
    {

        this.TokenInfo.UUID = iItem === -1 ? "" : this.TokenData[iItem].UUID;
        this.TokenInfo.Name = iItem === -1 ? "" : this.TokenData[iItem].Name;
        this.TokenInfo.AppURL = "http://rapida.us";
        this.TokenInfo.AppID = "http://rapida.us";
        this.TokenInfo.PublicKey = "";
        this.TokenInfo.KeyHandle = "";
        this.TokenInfo.PIN = "";
        this.TokenInfo.CPIN = "";

        var pSteps = [
            { name: global.StrName, component: <EnrollFIDOStep1 OnResult={OnResult} TokenInfo={this.TokenInfo}/> },
            { name: global.StrFIDOToken, component: <EnrollFIDOStep2 OnResult={OnResult} TokenInfo={this.TokenInfo}/> },
            { name: global.StrPIN, component: <EnrollFIDOStep3 OnResult={OnResult} TokenInfo={this.TokenInfo}/> },
        ];

        return pSteps;
    }

    OnTokenEnrolled(iItem)
    {

        console.log("EnrollFIDO::OnTokenEnrolled()");

        this.ReloadTokenData();
        /*if(iItem === -1)
            this.TokenData.push({ UUID: this.TokenInfo.UUID, Name: this.TokenInfo.Name });
        else
        {
            this.TokenData[iItem].UUID = this.TokenInfo.UUID;
            this.TokenData[iItem].Name = this.TokenInfo.Name;
        }*/

    }

    OnTokenRemoved(iItem)
    {
        console.log("EnrollFIDO::OnTokenRemoved(" + iItem + ")");
        RapidaIDService.UserFIDODel(this, this.TokenData[iItem].UUID, function(pThis, eResult) {
            pThis.ReloadTokenData();
            //if(eResult === RapidaIDMainDefs.ERROR_SUCCESS)
                //pThis.TokenData.splice(iItem, 1);
        });
    }

    render()
    {
        return (
            <EnrollBase 
                ImgTile={ImgTile} 
                EnrollTitle={global.StrEnrollNewToken} 
                BriefDesc={global.StrHereEnrollUpdateDeleteToken}
                TokenData={this.TokenData}
                TokenInfo={this.TokenInfo}
                OnPrepareEdit={this.OnPrepareEdit}
                OnTokenEnrolled={this.OnTokenEnrolled}
                OnTokenRemoved={this.OnTokenRemoved}
            />
        );
    }

}

export default EnrollFIDO;
